import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Select,
  Button,
  Radio,
  Space,
  message,
  notification,
  Modal,
} from "antd";
import dataService from "../networks/api/service/dataService"; // Adjust this import based on your project structure
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import colors from "../assets/styles/colour";

const { TextArea } = Input;
const { Option } = Select;

const GrievanceForm = () => {
  const [assemblyId, setAssemblyId] = useState("");
  const [panchayatId, setPanchayatId] = useState("");

  const [boothId, setBoothId] = useState("");
  const [constituencyId, setConstituencyId] = useState("");
  const [constituencyList, setConstituencyList] = useState([]);
  const [assemblyList, setAssemblyList] = useState([]);
  const [panchayatList, setPanchayatList] = useState([]);
  const [boothList, setBoothList] = useState([]);
  
  const [form] = Form.useForm();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [docResponse, setdocResponse] = useState(null);
  const [languageFlag, setLanguageFlag] = useState(false);
  const [draft, setDraft] = useState(null);
  const [selectedDraft, setSelectedDraft] = useState(null); // To handle selected draft

  const [districtId, setDistrictId] = useState(null);
  const [mandalText, setMandalText] = useState("");
  const [wardText, setWardText] = useState("");

const [subDistrictText, setSubDistrictText] = useState("");
const [talukaText, setTalukaText] = useState("");
const [gpText, setGpText] = useState("");
const [villageText, setVillageText] = useState("");


const [subDistrictId, setSubDistrictId] = useState(null);
const [talukaId, setTalukaId] = useState(null);
const [gpId, setGpId] = useState(null);
const [villageId, setVillageId] = useState(null);

const [districtList, setDistrictList] = useState([]);
const [subDistrictList, setSubDistrictList] = useState([]);
const [talukaList, setTalukaList] = useState([]);
const [gpList, setGpList] = useState([]);
const [villageList, setVillageList] = useState([]);


  const location = useLocation();
  const grievanceData = location.state?.grievanceData || {};
  console.log("Received Grievance Data:", grievanceData);
  const [isEditMode, setIsEditMode] = useState(false);
  const navigate = useNavigate();
 const path = location.pathname;
const videoRef = React.useRef(null);
const canvasRef = React.useRef(null);

const [cameraOpen, setCameraOpen] = useState(false);
const [stream, setStream] = useState(null);
const [previewUrl, setPreviewUrl] = useState(null);

  const isOffice = path.includes("grievance-to-office");
  const heading = languageFlag
    ? isEditMode
      ? isOffice
        ? "Edit Grievance To Office / କାର୍ଯ୍ୟାଳୟକୁ ଅଭିଯୋଗ ସମ୍ପାଦନ କରନ୍ତୁ"
        : "Edit Created Grievances / ଦଳକୁ ଅଭିଯୋଗ ସମ୍ପାଦନ କରନ୍ତୁ"
      : isOffice
      ? "Grievance To Office / କାର୍ଯ୍ୟାଳୟକୁ ଅଭିଯୋଗ"
      : "Create Grievances / ଅଭିଯୋଗ ଦାଖଲ କରନ୍ତୁ"
    : isEditMode
    ? isOffice
      ? "Edit Grievance To Office"
      : "Edit Create Grievances"
    : isOffice
    ? "Grievance To Office"
    : "Create Grievances";
  useEffect(() => {
  fetchDistricts();
}, []);

const fetchDistricts = async () => {
  try {
    const res = await dataService.getDistrict();
    if (res.code === 200) setDistrictList(res.data);
  } catch (e) {
    console.error(e);
  }
};

console.log("grievanceData keys:", Object.keys(grievanceData));
console.log("FULL grievanceData JSON:", JSON.stringify(grievanceData));
console.log("subDistrict value:", grievanceData.subDistrict, grievanceData.subdistrict);

useEffect(() => {
  // Opening Create Grievances from the menu reuses this route. Clear any
  // previous edit state when the navigation does not include a grievance.
  if (!grievanceData || Object.keys(grievanceData).length === 0) {
    setIsEditMode(false);
    form.resetFields();
    setDistrictId(null);
    setMandalText("");
    setWardText("");
    setSubDistrictText("");
    setTalukaText("");
    setGpText("");
    setVillageText("");
    return;
  }

  // hasPrefilled.current = true;
  setIsEditMode(true);

  const subDistrictVal =
    grievanceData.subDistrict ||
    grievanceData.subdistrict ||
    grievanceData.subDistrictName ||
    grievanceData.SubDistrictName ||
    "";
  const savedDistrictId =
    typeof grievanceData.district === "object"
      ? grievanceData.district?._id
      : grievanceData.district;

  form.setFieldsValue({
    grievanceOwner: grievanceData.grievanceOwner || "",
    takenBy: grievanceData.takenBy || "",
    location: grievanceData.location || "",
    nameOfApplicant: grievanceData.nameOfApplicant || "",
    mobileNo: grievanceData.mobileNo || "",
    problemRelatedToSection: grievanceData.problemRelatedToSection || "",
    descriptionOfProbles: grievanceData.descriptionOfProbles || "",
    levelOfIssue: grievanceData.levelOfIssue || "",
    authorityToBeSattled:
      grievanceData.authorityToBeSattled ??
      grievanceData.authorityToBeSettled ??
      "",
    contactPersonName:
      grievanceData.contactPersonName ?? grievanceData.authorityName ?? "",
    contactPersonMobileNo:
      grievanceData.contactPersonMobileNo ??
      grievanceData.contactNo ??
      grievanceData.contactPersonNumber ??
      "",
  });
  setDistrictId(savedDistrictId || null);
  setMandalText(grievanceData.mandal || "");
  setWardText(grievanceData.ward || "");
  setSubDistrictText(subDistrictVal);
  setTalukaText(grievanceData.taluka || "");
  setGpText(grievanceData.gp || "");
  setVillageText(grievanceData.village || "");


  const prefillLocation = async () => {
    try {
      let subDistrictData = [];
      let talukaData = [];
      let gpData = [];
      let villageData = [];
      let resolvedSubDistrictId = null;
      let resolvedSubDistrictText = subDistrictVal;
  
      // Step 1: Fetch subDistricts for the district
      if (savedDistrictId) {
        const res1 = await dataService.getSubDistrict(savedDistrictId);
        if (res1.code === 200) subDistrictData = res1.data;
      }

      // Legacy grievances may store the subdistrict ID. Display its name in
      // the free-text field instead of leaving the field with an ID or blank.
      const savedSubDistrict = subDistrictData.find(
        (sd) => sd._id === subDistrictVal
      );
      if (savedSubDistrict) {
        resolvedSubDistrictId = savedSubDistrict._id;
        resolvedSubDistrictText = savedSubDistrict.SubDistrictName || "";
      }
  
      // Step 2: Since subDistrict was never saved, derive it from taluka
      // Fetch ALL talukas by trying each subDistrict until we find the matching taluka
      if (grievanceData.taluka && subDistrictData.length > 0) {
        for (const sd of subDistrictData) {
          const res2 = await dataService.getTaluka(sd._id);
          if (res2.code === 200) {
            const found = res2.data.find(t => t._id === grievanceData.taluka);
            if (found) {
              resolvedSubDistrictId = sd._id;
              resolvedSubDistrictText =
                resolvedSubDistrictText || sd.SubDistrictName || "";
              talukaData = res2.data;
              console.log("Found subDistrict:", sd.SubDistrictName, sd._id);
              break; // ✅ Stop once we find the matching subDistrict
            }
          }
        }
      }
  
      // Step 3: Fetch GPs using taluka ID
      if (grievanceData.taluka) {
        const res3 = await dataService.getGp(grievanceData.taluka);
        if (res3.code === 200) gpData = res3.data;
      }
  
      // Step 4: Fetch Villages using gp ID
      if (grievanceData.gp) {
        const res4 = await dataService.getVillage(grievanceData.gp);
        if (res4.code === 200) villageData = res4.data;
      }
  
      console.log("Resolved subDistrictId:", resolvedSubDistrictId);
      console.log("talukaData sample:", talukaData[0]);
      console.log("gpData sample:", gpData[0]);
  
      // Step 5: Set all lists and IDs together
      setSubDistrictList(subDistrictData);
      setTalukaList(talukaData);
      setGpList(gpData);
      setVillageList(villageData);
  
      setDistrictId(savedDistrictId || null);
      setSubDistrictId(resolvedSubDistrictId);       // ✅ derived from taluka lookup
      setSubDistrictText(resolvedSubDistrictText);
      setTalukaId(grievanceData.taluka || null);
      setGpId(grievanceData.gp || null);
      setVillageId(grievanceData.village || null);
  
    } catch (e) {
      console.error("Error prefilling location:", e);
    }
  };

  prefillLocation();
}, [location.key]);

  const onFinish = (values) => {
    if (!districtId) {
      message.error("Please select a district");
      return;
    }
    console.log("Form Values:", {
      ...values,
      location:values.location,
        grievanceOwner: values.grievanceOwner,
    takenBy: values.takenBy,
      district: districtId || "",
      mandal: mandalText.trim(),
      ward: wardText.trim(),
      doc: docResponse,
      status: isEditMode ? "UPDATED" : "OPEN", // Set status based on edit mode
    });

    const updatepayload = {
      ...values,
      district: districtId,
      mandal: mandalText.trim(),
      ward: wardText.trim(),
      levelOfIssue: values.levelOfIssue || "",
      authorityToBeSattled: values.authorityToBeSattled || "",
      contactPersonName: values.contactPersonName || "",
      contactPersonMobileNo: values.contactPersonMobileNo || "",
      docs: docResponse,   
    };

    const payload = {
      ...values,
      // District is selected; Mandal and Ward are free-text fields.
      district: districtId,
      mandal: mandalText.trim(),
      ward: wardText.trim(),
      docs: docResponse,
      status: "OPEN",
      draftId: "",
    };
    // form.resetFields();

    if (isEditMode) {
      updateGrievanceForm(updatepayload);
      return;
    } else {
      uploadGrievanceForm(payload);
    }
  };

  const uploadGrievanceForm = async (payload) => {
    const response = await dataService.createGrievance(payload);
    if (response.code === 200) {
      // message.success(response.message);
      message.success(
       isEditMode
        ? "Grievance updated successfully!"
        : payload.status === "DRAFT"
        ? "Draft saved successfully!"
        : "Grievance submitted successfully!"
      );
       getDrafts();
      resetCompleteForm();
      form.resetFields();
      setAssemblyId("");
      setPanchayatId("");
      setConstituencyId("");
      setBoothId("");
      setAssemblyList([]);
      setPanchayatList([]);
      setBoothList([]);
      // navigate("/login/all-grievance")
    }
  };

  const updateGrievanceForm = async (abc) => {
    const grievanceId =
      grievanceData._id ||
      grievanceData.id ||
      grievanceData.grievanceId ||
      grievanceData.grievance_id;

    if (!grievanceId) {
      message.error("Unable to update: grievance ID is missing");
      return;
    }

    const response = await dataService.updatedGrievance(grievanceId, abc);
    if (response.code === 200) {
      message.success("Grievance updated successfully!");
      resetCompleteForm();
      form.resetFields();
      setAssemblyId("");
      setPanchayatId("");
      setConstituencyId("");
      setBoothId("");
      setAssemblyList([]);
      setPanchayatList([]);
      setBoothList([]);
      navigate("/login/all-grievance");
    }
  };

  const handleDraft = () => {
    // Get the form values without validation
    const draftData = form.getFieldsValue();
    const isFormEmpty = Object.values(draftData).every(
    (value) => value === undefined || value === null || value === ""
  );

  if (isFormEmpty) {
    message.warning("Please fill at least one field before saving draft");
    return;
  }

    console.log("Draft data:", draftData, selectedDraft);
    const payload = {
      ...draftData,
      status: "DRAFT",
      draftId: selectedDraft?._id,
    };
    uploadGrievanceForm(payload);
  };

  const toggleLanguage = () => {
    setLanguageFlag(!languageFlag);
  };

  const onFinishFailed = (errorInfo) => {
    console.error("Failed:", errorInfo);
    message.error("Please fill all required fields!");
  };

  // Fetch constituency list
  // const getConstituency = async () => {
  //   try {
  //     const res = await dataService.getDistrict();
  //     if (res.code === 200 && res.data.length > 0) {
  //       setConstituencyList  (res.data); // Store only the second constituency
  //     } else {
  //       setConstituencyList([]); // Handle case where there’s no second constituency
  //     }
  //   } catch (e) {
  //     console.error(e);
  //   }
  // };

  

  const getDrafts = async () => {
    try {
      const res = await dataService.getDraft();
      if (res.code === 200) {
        setDraft(res.data);
      } else {
        notification.error({ message: "Failed to fetch drafts" });
      }
    } catch (e) {
      console.error("Error fetching drafts:", e);
      notification.error({
        message: "An error occurred while fetching drafts",
      });
    }
  };

 const handleDraftChange = (value) => {
  const selected = draft.find((d) => d._id === value);

  if (!selected) return;

  setSelectedDraft(selected);

  form.setFieldsValue({
    grievanceOwner: selected.grievanceOwner,
    takenBy: selected.takenBy,
    nameOfApplicant: selected.nameOfApplicant,
    mobileNo: selected.mobileNo,
    problemRelatedToSection: selected.problemRelatedToSection,
    descriptionOfProbles: selected.descriptionOfProbles,
    levelOfIssue: selected.levelOfIssue,
    authorityToBeSattled: selected.authorityToBeSattled,
    contactPersonName: selected.contactPersonName,
    contactPersonMobileNo: selected.contactPersonMobileNo,
    
  });
};

  useEffect(() => {
    getDrafts();
  
  }, []);


const filterOption = (input, option) =>
  option?.children
    ?.toLowerCase()
    .includes(input.toLowerCase());

 

const onDistrictSelect = async (id) => {
  setDistrictId(id);
  setSubDistrictId(null);
  setTalukaId(null);
  setGpId(null);
  setVillageId(null);

  setSubDistrictList([]);
  setTalukaList([]);
  setGpList([]);
  setVillageList([]);

  try {
    const res = await dataService.getSubDistrict(id);
    if (res.code === 200) setSubDistrictList(res.data);
  } catch (e) {
    console.error(e);
  }
};

const onSubDistrictSelect = async (id) => {
  setSubDistrictId(id);
  setTalukaId(null);
  setGpId(null);
  setVillageId(null);

  setTalukaList([]);
  setGpList([]);
  setVillageList([]);

  try {
    const res = await dataService.getTaluka(id);
    if (res.code === 200) setTalukaList(res.data);
  } catch (e) {
    console.error(e);
  }
};

const onTalukaSelect = async (id) => {
  setTalukaId(id);
  setGpId(null);
  setVillageId(null);

  setGpList([]);
  setVillageList([]);

  try {
    const res = await dataService.getGp(id);
    if (res.code === 200) setGpList(res.data);
  } catch (e) {
    console.error(e);
  }
};

const onGpSelect = async (id) => {
  setGpId(id);
  setVillageId(null);
  setVillageList([]);

  try {
    const res = await dataService.getVillage(id);
    if (res.code === 200) setVillageList(res.data);
  } catch (e) {
    console.error(e);
  }
};


const sortByName = (key) => {
  return (a, b) =>
    (a[key] || "").localeCompare(b[key] || "", "en", {
      sensitivity: "base",
    });
};

  // API call function
  const uploadDocument = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const res = await dataService.uploadDoc(formData); // Assuming your API accepts FormData
      setdocResponse(res.data);
      message.success("File uploaded successfully");
    } catch (e) {
      message.error("Failed to upload file");
      console.error(e);
    }
  };

  const openCamera = async () => {
  try {
    const mediaStream = await navigator.mediaDevices.getUserMedia({
      video: true,
    });

    setStream(mediaStream);
    setCameraOpen(true);

    setTimeout(() => {
      if (videoRef.current) {
        videoRef.current.srcObject = mediaStream;
      }
    }, 300);
  } catch (err) {
    message.error("Camera permission denied or not available");
    console.error(err);
  }
};

const closeCamera = () => {
  stream?.getTracks().forEach((track) => track.stop());
  setCameraOpen(false);
};

const captureImage = () => {
  const video = videoRef.current;
  const canvas = canvasRef.current;

  if (!video || !canvas) return;

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;

  const ctx = canvas.getContext("2d");
  ctx.drawImage(video, 0, 0);

  const imageDataUrl = canvas.toDataURL("image/png");

  fetch(imageDataUrl)
    .then(res => res.blob())
    .then(blob => {
      const file = new File([blob], "camera-image.jpg", {
        type: "image/jpg",
      });

      setUploadedFile(file);
      setPreviewUrl(imageDataUrl);

      // 🔥 GUARANTEED API CALL
      uploadDocument(file);
    })
    .catch(err => {
      console.error("Image capture failed:", err);
      message.error("Failed to capture image");
    });

  closeCamera();
};
const resetCompleteForm = () => {
  form.resetFields();

  setUploadedFile(null);
  setPreviewUrl(null);
  setdocResponse(null);

  setDistrictId(null);
  setMandalText("");
  setWardText("");
  setSubDistrictId(null);
  setTalukaId(null);
  setGpId(null);
  setVillageId(null);
  setSubDistrictText("");
  setTalukaText("");
  setGpText("");
  setVillageText("");

  setSubDistrictList([]);
  setTalukaList([]);
  setGpList([]);
  setVillageList([]);

  setAssemblyId("");
  setPanchayatId("");
  setConstituencyId("");
  setBoothId("");

  setAssemblyList([]);
  setPanchayatList([]);
  setBoothList([]);
};

  const problemTypes = [
  "Animals",
  "Agriculture & Irrigation",
  "All Certificate",
  "Awas Yojana",
  "Business",
  "Drinking Water",
  "Education",
  "Electricity",
  "Forest & Environment",
  "Health",
  "Labour",
  "Law & Order",
  "Law & Police",
  "Migrants (Anupraveshkari)",
  "Mining",
  "Mobile Network",
  "Others",
  "Pension",
  "Pravasi Odia",
  "Ration Card",
  "Religious Place",
  "Road & Transport",
  "Temple",
  "Women & Child Welfare",
].sort((a, b) =>
  a.localeCompare(b, "en", { sensitivity: "base" })
);


  // const handleFileUpload = (file) => {
  //   const allowedFormats = [
  //     "application/pdf",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     "application/msword",
  //   ];
  //   if (!allowedFormats.includes(file.type)) {
  //     message.error(
  //       "Invalid file format. Only .xlsx, .pdf, and .doc are allowed."
  //     );
  //     return Upload.LIST_IGNORE;
  //   }

  //   setUploadedFile(file);
  //   uploadDocument(file);
  //   return false;
  // };
 
  const handleFileUpload = (file) => {
  const allowedFormats = [
    "application/pdf",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/msword",
    "image/jpeg",
    "image/png",
    "image/jpg",
  ];

  if (!allowedFormats.includes(file.type)) {
    message.error(
      "Invalid file format. Only .xlsx, .pdf, .doc, .jpg, .png are allowed."
    );
    return Upload.LIST_IGNORE;
  }

  setUploadedFile(file);
  uploadDocument(file);
  return false;
};
 
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Button onClick={toggleLanguage} style={{ marginBottom: "1rem" }}>
          {languageFlag ? "Switch to English Only" : "Switch to Bilingual"}
        </Button>

       <Select
  placeholder="Select Draft"
  style={{ width: 300, marginBottom: 20 }}
  onChange={handleDraftChange}
>
  {draft?.map((d, index) => (
    <Select.Option key={d._id} value={d._id}>
      {`Draft ${index + 1}`}
    </Select.Option>
  ))}
</Select>
      </div>

      <Form
        layout="vertical"
        onFinish={onFinish}
        form={form}
        //   onFinishFailed={onFinishFailed}
        style={{
          maxWidth: 800,
          margin: "0 auto",
          padding: "2rem",
          backgroundColor: "#f7f7f7",
          borderRadius: "8px",
        }}
      >
        <h2 style={{ textAlign: "center", color: colors.textColor }}>
          {heading}
        </h2>
  
        <Form.Item
  label="Grievance Owner (User & Designation)"
  name="grievanceOwner"
  
>
  <Input
    placeholder="Enter grievance owner name & designation"
  />
</Form.Item>

<Form.Item
  label="Taken by - user who is uploading the details of applicant (Name)"
  name="takenBy"
 
>
  <Input
    placeholder="Uploader name or email"
   
  />
</Form.Item>

        {/* <Form.Item
          label={languageFlag ? "E-mail / ଇ-ମେଲ୍" : "E-mail"}
          name="email"
          rules={[{ required: true, message: "Please enter your email" }]}
        >
          <Input placeholder="Enter your email" />
        </Form.Item> */}
        {/* <Form.Item
          label={languageFlag ? "E-mail / ଇ-ମେଲ୍" : "E-mail"}
          name="email"
          rules={[
            // { required: true, message: "Please enter your email" },
            {
              pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: "Please enter a valid email address",
            },
          ]}
        >
          <Input placeholder="Enter your email" disabled={isEditMode} />
        </Form.Item> */}

        <Form.Item
          label={
            languageFlag
              ? "Name of the Applicant / ଆବେଦନକାରୀଙ୍କ ନାମ"
              : "Name of the Applicant"
          }
          name="nameOfApplicant"
          rules={[
            { required: true, message: "Please enter your name" },
            {
              pattern: /^[A-Za-z\s]+$/,
              message: "Only letters and spaces are allowed",
            },
          ]}
        >
          <Input placeholder="Enter your name" disabled={isEditMode} />
        </Form.Item>

        <Form.Item
          label={
            languageFlag
              ? "Mobile Nos of the Applicant / ଆବେଦନକାରୀଙ୍କ ମୋବାଇଲ୍ ନମ୍ବର"
              : "Mobile Nos of the Applicant"
          }
          name="mobileNo"
          rules={[
            { required: true, message: "Please enter your mobile number" },
            {
              pattern: /^[0-9]{10}$/,
              message: "Please enter exactly 10 digits",
            },
          ]}
        >
          <Input
            placeholder="Enter your mobile number"
            maxLength={10}
            disabled={isEditMode}
          />
        </Form.Item>

        {/* Dynamic Select Inputs for Constituency, Assembly, Panchayat, and Booth */}

      <Form.Item
  label={languageFlag ? "Location Details / ଠିକଣା" : "Location Details"}
  required
>
  <Space wrap>
    <Select
      placeholder="Select Zilla"
      value={districtId}
      onChange={onDistrictSelect}
      disabled={isEditMode}
      showSearch
      filterOption={filterOption}
      style={{ width: 200 }}
    >
      {districtList
        .slice()
        .sort(sortByName("districtName"))
        .map((d) => (
          <Option key={d._id} value={d._id}>
            {d.districtName}
          </Option>
        ))}
    </Select>

    <Input
      placeholder="Mandal"
      value={mandalText}
      onChange={(e) => setMandalText(e.target.value)}
      disabled={isEditMode}
      style={{ width: 160 }}
    />

    <Input
      placeholder="Ward"
      value={wardText}
      onChange={(e) => setWardText(e.target.value)}
      disabled={isEditMode}
      style={{ width: 160 }}
    />
  </Space>
</Form.Item>
{/* //Optionally */}

{/* <Form.Item
  label="Location"
  name="location"
>
  <Input
    placeholder="location details"
   
  />
</Form.Item> */}

        <Form.Item
          label={
            languageFlag
              ? "Problems related to which section / କେଉଁ ବିଭାଗ ସହିତ ଜଡିତ ସମସ୍ୟା"
              : "Problems related to which section"
          }
          name="problemRelatedToSection"
          rules={[{ required: true, message: "Please select a category" }]}
        >


          {/* <Select
            showSearch
            optionFilterProp="children"
            disabled={isEditMode}
            filterOption={(input, option) => {
              const children = option?.children;
              return String(children)
                .toLowerCase()
                .includes(input.toLowerCase());
            }}
            placeholder="Select a category"
          >
            <Select.Option value="Education">Education</Select.Option>
            <Select.Option value="Health">Health</Select.Option>
            <Select.Option value="Awas Yojana">Awas Yojana</Select.Option>
            <Select.Option value="Drinking Water">Drinking Water</Select.Option>
            <Select.Option value="Electricity">Electricity</Select.Option>
            <Select.Option value="Mobile Network">Mobile Network</Select.Option>
            <Select.Option value="Agriculture & Irrigation">
              Agriculture & Irrigation
            </Select.Option>
            <Select.Option value="Road & Transport">
              Road & Transport
            </Select.Option>
            <Select.Option value="Revenue">Revenue</Select.Option>
            <Select.Option value="Pension">Pension</Select.Option>
            <Select.Option value="All Certificate">
              All Certificate
            </Select.Option>
            <Select.Option value="Law & Police">Law & Police</Select.Option>
            <Select.Option value="Forest & Environment">
              Forest & Environment
            </Select.Option>
            <Select.Option value="Other">Other</Select.Option>
          </Select> */}

          <Select
  showSearch
  optionFilterProp="children"
  disabled={isEditMode}
  filterOption={(input, option) =>
    option?.children
      ?.toString()
      .toLowerCase()
      .includes(input.toLowerCase())
  }
  placeholder="Select a category"
>
  {problemTypes.map((type) => (
    <Select.Option key={type} value={type}>
      {type}
    </Select.Option>
  ))}
</Select>

        </Form.Item>

        <Form.Item
          label={
            languageFlag
              ? "Description of the problem / ସମସ୍ୟାର ବର୍ଣ୍ଣନା"
              : "Description of the problem"
          }
          name="descriptionOfProbles"
          rules={[
            {
              required: true,
              message: "Please provide a description of the problem",
            },
          ]}
        >
          <TextArea
            rows={4}
            placeholder="Describe the issue you are facing"
            disabled={isEditMode}
          />
        </Form.Item>

        <Form.Item
          label={
            languageFlag
              ? "Which Level Issue / କେଉଁ ସ୍ତରର ସମସ୍ୟା"
              : "Which Level Issue"
          }
          name="levelOfIssue"
          rules={[
            {
              // required: true,
              message: "Please select the level of issue",
            },
          ]}
        >
          <Radio.Group>
            <Space direction="vertical">
              <Radio value="State Level">State Level</Radio>
              <Radio value="District Level">District Level</Radio>
              <Radio value="Block Level">Block Level</Radio>
              <Radio value="Gram Panchayat Level">Gram Panchayat Level</Radio>
              <Radio value="NAC / Municipality Level">NAC / Municipality Level</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>

        <Form.Item
          label={
            languageFlag
              ? "Assigned to Authority (Department) :/ କେଉଁ କର୍ତ୍ତୃପକ୍ଷ ସମାଧାନ କରିପାରିବେ"
              : "Assigned to Authority (Department) :"
          }
          name="authorityToBeSattled"
          rules={[
            {
              // required: true,
              message: "Please select the authority for settlement",
            },
          ]}
        >
          <Select placeholder="Select the authority">
            <Select.Option value="Revenue inspector">
              Revenue Inspector
            </Select.Option>
            <Select.Option value="Headmaster">Headmaster</Select.Option>
            <Select.Option value="Health Worker">Health Worker</Select.Option>
            <Select.Option value="Sarapanch">Sarapanch</Select.Option>
            <Select.Option value="BDO">BDO (Block Development Officer)</Select.Option>
            <Select.Option value="Tahasildar">Tahasildar</Select.Option>

            <Select.Option value="Police station">Police Station</Select.Option>
            <Select.Option value="Executive Engineer">
              Executive Engineer
            </Select.Option>
            <Select.Option value="Assistant Engineer">
              Assistant Engineer
            </Select.Option>
            <Select.Option value="Junior Engineer">
              Junior Engineer
            </Select.Option>
            <Select.Option value="BEO">BEO (Block Education Officer)</Select.Option>
            <Select.Option value="CHC Incharge">CHC Incharge</Select.Option>
            <Select.Option value="Collector">Collector</Select.Option>
            <Select.Option value="SP">SP (Superintendent of Police)</Select.Option>
            <Select.Option value="DEO">DEO(Dist Endowment Officer)</Select.Option>
            <Select.Option value="Dist Agriculture Officer">
              Dist Agriculture Officer
            </Select.Option>
            <Select.Option value="DIC">DIC (District Industries Centre)</Select.Option>
            <Select.Option value="DFO">DFO (Divisional Forest Officer)</Select.Option>
            <Select.Option value="CDVO">CDVO(Chief District Veterinary Officer)</Select.Option>
            <Select.Option value="CDMO">CDMO (Chief District Medical Officer)</Select.Option>
            <Select.Option value="Co Operative">Co Operative</Select.Option>
            <Select.Option value="SDO (Electrical)">
              SDO (Electrical)
            </Select.Option>
            <Select.Option value="Dist Postal Officer">
              Dist Postal Officer
            </Select.Option>
            <Select.Option value="Dist Endowment Officer">
              Dist Endowment Officer
            </Select.Option>
            <Select.Option value="Dist Fire Officer">
              Dist Fire Officer
            </Select.Option>

            <Select.Option value="Other">Other</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item
          label={
            languageFlag
              ? "Authority Name/ ଯେଉଁ ଅଧିକାରୀଙ୍କ ସହିତ ଆପଣଙ୍କୁ ବିଶେଷ ଭାବରେ କହିବାକୁ ପଡିବ ସେହି ଅଧିକାରୀଙ୍କ ନାମ ଉଲ୍ଲେଖ କରନ୍ତୁ"
              : "Authority Name"
          }
          name="contactPersonName"
          rules={[
            {
              pattern: /^[A-Za-z\s]+$/,
              message: "Only letters and spaces are allowed",
            },
          ]}
        >
          <Input placeholder="Enter contact person name" />
        </Form.Item>

        {/* <Form.Item
          label={
            languageFlag
              ? "Mention the number of the officer to whom you have to speak in particular / ଯେଉଁ ଅଧିକାରୀଙ୍କ ସହିତ ଆପଣଙ୍କୁ ବିଶେଷ ଭାବରେ କହିବାକୁ ପଡିବ ସେହି ଅଧିକାରୀଙ୍କ ମୋବାଇଲ୍ ନମ୍ବର ଉଲ୍ଲେଖ କରନ୍ତୁ"
              : "Mention the number of the officer to whom you have to speak in particular"
          }
          name="contactPersonMobileNo"
          rules={[
            {
              required: true,
              message: "Please enter a valid 10-digit mobile number",
            },
            {
              pattern: /^\d{10}$/,
              message: "Please enter a valid 10-digit mobile number",
            },
          ]}
        >
          <Input placeholder="Enter contact person number" maxLength={10} />
        </Form.Item> */}
        <Form.Item
          label={
            languageFlag
              ? "contact no (if any)/ ଯେଉଁ ଅଧିକାରୀଙ୍କ ସହିତ ଆପଣଙ୍କୁ ବିଶେଷ ଭାବରେ କହିବାକୁ ପଡିବ ସେହି ଅଧିକାରୀଙ୍କ ମୋବାଇଲ୍ ନମ୍ବର ଉଲ୍ଲେଖ କରନ୍ତୁ"
              : "contact no (if any)"
          }
          name="contactPersonMobileNo"
          rules={[
            {
              pattern: /^\d{10}$/,
              message: "Please enter a valid 10-digit mobile number",
            },
          ]}
        >
          <Input
            placeholder="Enter contact person number"
            maxLength={10}
            onKeyPress={(e) => {
              if (!/[0-9]/.test(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>

        <Form layout="vertical">
          {/* <Form.Item label="Upload Document">
            <Upload
              beforeUpload={handleFileUpload}
              showUploadList={false} // Prevents showing the default upload list
            >
              <Button icon={<UploadOutlined />}>
                {languageFlag
                  ? "Upload File / ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ"
                  : "Uplaod File"}
              </Button>
            </Upload>
            {uploadedFile && (
              <p>
                Uploaded file: <strong>{uploadedFile.name}</strong>
              </p>
            )}
          </Form.Item> */}
         <Form.Item label="Upload Document">
  <div style={{ display: "flex", gap: "10px" }}>

    {/* Desktop / Laptop Camera */}
    <Button type="primary" onClick={openCamera} style={{background: colors.buttoSecondary}}>
      📷 Open Camera
    </Button>

    {/* Normal Upload */}
    <Upload
      beforeUpload={handleFileUpload}
      showUploadList={false}
      accept=".pdf,.doc,.docx,.xlsx,image/*"
    >
      <Button icon={<UploadOutlined style={{color: colors.green}} />} style={{borderColor: colors.green, borderWidth: 2, }}>
        {languageFlag
          ? "Upload File / ଫାଇଲ୍ ଅପଲୋଡ୍ କରନ୍ତୁ"
          : "Upload File"}
      </Button>
    </Upload>
  </div>

  {/* Image Preview */}
  {previewUrl && (
    <div style={{ marginTop: 15 }}>
      <img
        src={previewUrl}
        alt="preview"
        style={{
          width: 200,
          borderRadius: 8,
          border: "1px solid #ddd",
        }}
      />
    </div>
  )}

  {/* File Name for PDFs etc */}
  {uploadedFile && !previewUrl && (
    <p style={{ marginTop: 10 }}>
      Uploaded file: <strong>{uploadedFile.name}</strong>
    </p>
  )}
</Form.Item>
        </Form>

        <Form.Item>
          {!isEditMode && (
             <Button
             type="primary"
             style={{ width: "100%",backgroundColor:"white", borderColor : colors.button, color : colors.button }}
             onClick={handleDraft}
             
           >
             Save as Draft
           </Button>
          )}
         
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ width: "100%", backgroundColor : colors.button }}>
          {languageFlag
  ? isEditMode
    ? "Update Grievance / ଅଭିଯୋଗ ସଂପାଦନ କରନ୍ତୁ"
    : "Submit Grievance / ଅଭିଯୋଗ ଦାଖଲ କରନ୍ତୁ"
  : isEditMode
    ? "Update Grievance"
    : "Submit Grievance"}
          </Button>
        </Form.Item>
        <Modal
  open={cameraOpen}
  onCancel={closeCamera}
  footer={null}
  width={600}
>
  <video
    ref={videoRef}
    autoPlay
    style={{ width: "100%", borderRadius: 10 }}
  />
  <canvas ref={canvasRef} style={{ display: "none" }} />

  <div style={{ marginTop: 15, textAlign: "center" }}>
    <Button type="primary" onClick={captureImage}>
      Capture
    </Button>
  </div>
</Modal>
      </Form>
    </div>
  );
};

export default GrievanceForm;
